import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "snore-setting"
};
var _hoisted_2 = {
  key: 0,
  class: "loading"
};
var _hoisted_3 = {
  class: "dialog-inner"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "custom-title"
};

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "vip-tag"
}, "VIP", -1);

var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "tips"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "custom-title"
};

var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "vip-tag"
}, "VIP", -1);

var _hoisted_13 = ["src"];
var _hoisted_14 = {
  class: "custom-title"
};

var _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "vip-tag"
}, "VIP", -1);

var _hoisted_16 = ["src"];
var _hoisted_17 = {
  class: "tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_loading = _resolveComponent("van-loading");

  var _component_no_net_tip = _resolveComponent("no-net-tip");

  var _component_van_cell = _resolveComponent("van-cell");

  var _component_van_radio = _resolveComponent("van-radio");

  var _component_van_radio_group = _resolveComponent("van-radio-group");

  var _component_Dialog = _resolveComponent("Dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.isloading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_loading, {
    size: "24",
    color: "#3F96F3"
  })])) : _ctx.noNet ? (_openBlock(), _createBlock(_component_no_net_tip, {
    key: 1
  })) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [!$data.hideStorageMethodEntry ? (_openBlock(), _createBlock(_component_van_cell, {
    key: 0,
    title: _ctx.$t('message.snore.storageMethods'),
    "is-link": !$data.hideStorageMethodEntry,
    value: _ctx.type === 'local' ? _ctx.$t('message.snore.local') : _ctx.$t('message.snore.cloud'),
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.toDetail('location');
    })
  }, null, 8, ["title", "is-link", "value"])) : _createCommentVNode("", true), _createVNode(_component_van_cell, {
    title: _ctx.$t('message.snore.storageDurations'),
    "is-link": "",
    value: $options.storageDurationText,
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.toDetail('duration');
    })
  }, null, 8, ["title", "value"])], 64)), _createVNode(_component_Dialog, {
    key: "methods",
    dialogShow: $data.methodsDialogShow,
    title: _ctx.$t('message.snore.storageMethods'),
    onClickMask: $options.clickMask
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_radio_group, {
        modelValue: _ctx.type,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _ctx.type = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            title: _ctx.$t('message.snore.localStorage'),
            clickable: "",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return $options.changeType('local');
            })
          }, {
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_radio, {
                name: "local"
              }, {
                icon: _withCtx(function (props) {
                  return [_createElementVNode("img", {
                    class: "img-icon",
                    src: props.checked ? $data.activeIcon : $data.inactiveIcon
                  }, null, 8, _hoisted_4)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["title"]), _createVNode(_component_van_cell, {
            title: _ctx.$t('message.snore.cloudStorage'),
            clickable: "",
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return $options.changeType('cloud');
            })
          }, {
            title: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('message.snore.cloudStorage')), 1), _hoisted_6];
            }),
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_radio, {
                name: "cloud"
              }, {
                icon: _withCtx(function (props) {
                  return [_createElementVNode("img", {
                    class: "img-icon",
                    src: props.checked ? $data.activeIcon : $data.inactiveIcon
                  }, null, 8, _hoisted_7)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["title"])];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('message.snore.storageWayTips')), 1)])];
    }),
    _: 1
  }, 8, ["dialogShow", "title", "onClickMask"]), _createVNode(_component_Dialog, {
    key: "duration",
    dialogShow: $data.durationDialogShow,
    title: _ctx.$t('message.snore.storageDurations'),
    onClickMask: $options.clickMask
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_radio_group, {
        modelValue: _ctx.days,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return _ctx.days = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            title: 1 + _ctx.$t('message.snore.day'),
            clickable: "",
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return $options.changeDays(1);
            })
          }, {
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_radio, {
                name: 1
              }, {
                icon: _withCtx(function (props) {
                  return [_createElementVNode("img", {
                    class: "img-icon",
                    src: props.checked ? $data.activeIcon : $data.inactiveIcon
                  }, null, 8, _hoisted_9)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["title"]), _createVNode(_component_van_cell, {
            title: 7 + _ctx.$t('message.snore.days'),
            clickable: "",
            onClick: _cache[6] || (_cache[6] = function ($event) {
              return $options.changeDays(7);
            })
          }, {
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_radio, {
                name: 7
              }, {
                icon: _withCtx(function (props) {
                  return [_createElementVNode("img", {
                    class: "img-icon",
                    src: props.checked ? $data.activeIcon : $data.inactiveIcon
                  }, null, 8, _hoisted_10)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["title"]), $options.showVipDays ? (_openBlock(), _createBlock(_component_van_cell, {
            key: 0,
            title: 30 + _ctx.$t('message.snore.days'),
            clickable: "",
            onClick: _cache[7] || (_cache[7] = function ($event) {
              return $options.changeDays(30);
            })
          }, {
            title: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_11, "30" + _toDisplayString(_ctx.$t('message.snore.days')), 1), _hoisted_12];
            }),
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_radio, {
                name: 30
              }, {
                icon: _withCtx(function (props) {
                  return [_createElementVNode("img", {
                    class: "img-icon",
                    src: props.checked ? $data.activeIcon : $data.inactiveIcon
                  }, null, 8, _hoisted_13)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["title"])) : _createCommentVNode("", true), $options.showVipDays ? (_openBlock(), _createBlock(_component_van_cell, {
            key: 1,
            title: 180 + _ctx.$t('message.snore.days'),
            clickable: "",
            onClick: _cache[8] || (_cache[8] = function ($event) {
              return $options.changeDays(180);
            })
          }, {
            title: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_14, "180" + _toDisplayString(_ctx.$t('message.snore.days')), 1), _hoisted_15];
            }),
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_radio, {
                name: 180
              }, {
                icon: _withCtx(function (props) {
                  return [_createElementVNode("img", {
                    class: "img-icon",
                    src: props.checked ? $data.activeIcon : $data.inactiveIcon
                  }, null, 8, _hoisted_16)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["title"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_17, _toDisplayString($options.showVipDays ? _ctx.$t('message.snore.storagePeriod') : _ctx.$t('message.snore.storagePeriodWearCopilot')), 1)];
    }),
    _: 1
  }, 8, ["dialogShow", "title", "onClickMask"])]);
}